import { Grid, Typography } from "@mui/material";

import { FairPaySurveyResponse } from "features/FairPaySurvey/schemas";

const styles = {
  badge: {
    my: 2,
    background: "#F7EE6F",
    p: 5,
    borderRadius: "20px",
  },
  descriptionFirstText: {
    textAlign: "center",
    fontWeight: 600,
    mb: 1,
    fontSize: "18px",
  },
  descriptionLargeText: {
    textAlign: "center",
    fontSize: "28px",
    fontWeight: 600,
    mb: 2,
  },
  descriptionText: { textAlign: "center", fontSize: 16 },
};

export default function BiggestBrandDeal({
  surveyResponse,
}: {
  surveyResponse: FairPaySurveyResponse | null;
}) {
  if (!surveyResponse) {
    return <></>;
  }

  if (!surveyResponse?.brandIncomePercentile) {
    return <></>;
  }

  return (
    <Grid item xs={12} justifyContent="center" container sx={styles.badge}>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionFirstText}>
          Your biggest brand deal with
        </Typography>
      </Grid>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionLargeText}>
          {surveyResponse.highestEarningBrand}
        </Typography>
      </Grid>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionText}>
          Was{" "}
          {surveyResponse.brandIncomePercentile < 25
            ? "on the lower end"
            : surveyResponse.brandIncomePercentile < 50
              ? "slightly below average"
              : surveyResponse.brandIncomePercentile < 75
                ? "slightly above average"
                : "on the higher end"}{" "}
          compared to other creators.{" "}
          {surveyResponse.brandIncomePercentile < 50
            ? "Next time, you can confidently ask for more."
            : "Give yourself a pat on the back!"}
        </Typography>
      </Grid>
    </Grid>
  );
}
